<div class="container">	
	<div class="row">
		<div class="col-md-6 order-sm-12 m-t-40">
			<alert></alert>
		    <h2>Login</h2>
		    <form name="form" (ngSubmit)="f.form.valid && login()" #f="ngForm" novalidate>
		        <div class="form-group" [ngClass]="{ 'has-error': f.submitted && !email.valid }">
		            <label for="email">Email</label>
		            <input type="text" class="form-control" name="email" [(ngModel)]="model.email" #email="ngModel" required />
		            <div *ngIf="f.submitted && !email.valid" class="help-block">Email is required</div>
		        </div>
		        <div class="form-group" [ngClass]="{ 'has-error': f.submitted && !password.valid }">
		            <label for="password">Password</label>
		            <input type="password" class="form-control" name="password" [(ngModel)]="model.password" #password="ngModel" required />
		            <div *ngIf="f.submitted && !password.valid" class="help-block">Password is required</div>
		        </div>
		        <div class="form-group">
		            <button [disabled]="loading" class="btn btn-primary">Login</button>
		            <img *ngIf="loading" src="data:image/gif;base64,R0lGODlhEAAQAPIAAP///wAAAMLCwkJCQgAAAGJiYoKCgpKSkiH/C05FVFNDQVBFMi4wAwEAAAAh/hpDcmVhdGVkIHdpdGggYWpheGxvYWQuaW5mbwAh+QQJCgAAACwAAAAAEAAQAAADMwi63P4wyklrE2MIOggZnAdOmGYJRbExwroUmcG2LmDEwnHQLVsYOd2mBzkYDAdKa+dIAAAh+QQJCgAAACwAAAAAEAAQAAADNAi63P5OjCEgG4QMu7DmikRxQlFUYDEZIGBMRVsaqHwctXXf7WEYB4Ag1xjihkMZsiUkKhIAIfkECQoAAAAsAAAAABAAEAAAAzYIujIjK8pByJDMlFYvBoVjHA70GU7xSUJhmKtwHPAKzLO9HMaoKwJZ7Rf8AYPDDzKpZBqfvwQAIfkECQoAAAAsAAAAABAAEAAAAzMIumIlK8oyhpHsnFZfhYumCYUhDAQxRIdhHBGqRoKw0R8DYlJd8z0fMDgsGo/IpHI5TAAAIfkECQoAAAAsAAAAABAAEAAAAzIIunInK0rnZBTwGPNMgQwmdsNgXGJUlIWEuR5oWUIpz8pAEAMe6TwfwyYsGo/IpFKSAAAh+QQJCgAAACwAAAAAEAAQAAADMwi6IMKQORfjdOe82p4wGccc4CEuQradylesojEMBgsUc2G7sDX3lQGBMLAJibufbSlKAAAh+QQJCgAAACwAAAAAEAAQAAADMgi63P7wCRHZnFVdmgHu2nFwlWCI3WGc3TSWhUFGxTAUkGCbtgENBMJAEJsxgMLWzpEAACH5BAkKAAAALAAAAAAQABAAAAMyCLrc/jDKSatlQtScKdceCAjDII7HcQ4EMTCpyrCuUBjCYRgHVtqlAiB1YhiCnlsRkAAAOwAAAAAAAAAAAA==" />
		        </div>
		        <div *ngIf="error" class="alert alert-danger">{{error}}</div>
		    </form>
		</div>
		<div class="col-md-6 order-sm-1 m-t-40">
			<h2>Create Account</h2>
			<p>Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod
			tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam,
			quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo
			consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse
			cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non
			proident, sunt in culpa qui officia deserunt mollit anim id est laborum.</p>
			<button class="btn btn-primary">Register</button>
		</div>

	</div>
</div>